export default __webpack_public_path__ + "static/media/88.bc34612b.png";